import React from 'react';
import { motion } from 'framer-motion';
export function Testimonials2() {
  const testimonials = [{
    initials: 'AL',
    quote: 'No es un libro más. Es tiempo real con mis hijos. Cada cita es un momento que atesoramos.',
    name: 'Andrea L.',
    location: 'Santa Fe',
    role: 'Mamá de adolescente',
    badge: null
  }, {
    initials: 'RG',
    quote: 'Mis hijos ahora me buscan para hacer las citas. Antes era al revés. Eso no tiene precio.',
    name: 'Roberto G.',
    location: 'Rosario',
    role: 'Papá de 3 hijos',
    badge: null
  }, {
    initials: 'VP',
    quote: 'Lo mejor es que no necesitás planificar nada. Abrís el libro, elegís una cita y listo.',
    name: 'Valeria P.',
    location: 'Tucumán',
    role: 'Mamá de familia',
    badge: null
  }, {
    initials: 'DM',
    quote: 'Nos cambió la dinámica familiar. Ahora tenemos nuestro momento sagrado cada día.',
    name: 'Diego M.',
    location: 'Mendoza',
    role: 'Papá de 2 hijos',
    badge: 'Pack Completo'
  }];
  return <section className="cv-auto py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-242">
      <div className="max-w-5xl mx-auto" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-244">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-245">
            ❤️ MÁS FAMILIAS CREANDO RECUERDOS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-246">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: i * 0.08,
          duration: 0.3
        }} className="bg-navy-900 border border-navy-800 rounded-2xl p-6 relative" data-id="element-247">
              {t.badge && <div className="absolute -top-3 right-6 bg-gold-500 text-navy-900 font-bold px-3 py-0.5 rounded-full text-xs shadow-lg" data-id="element-248">
                  {t.badge}
                </div>}

              <div className="text-sm mb-4" data-id="element-249">⭐⭐⭐⭐⭐</div>

              <div className="flex items-start gap-4" data-id="element-250">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center text-white font-bold text-sm flex-shrink-0" data-id="element-251">
                  {t.initials}
                </div>
                <div className="flex-1" data-id="element-252">
                  <p className="text-slate-300 italic mb-4 leading-relaxed" data-id="element-253">
                    "{t.quote}"
                  </p>
                  <p className="font-bold text-white text-sm" data-id="element-254">{t.name}</p>
                  <p className="text-slate-400 text-xs" data-id="element-255">
                    {t.location} · {t.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}